import { useQuery } from '@tanstack/react-query';
import Config from 'src/common/Config';
import type { BotStatus } from 'src/meetings/models';

const API_URL = Config.getApiUrl();

type UseBotStatusResult = {
  botStatus: BotStatus | undefined;
  isLoading: boolean;
  error: Error | null;
  refetch: () => void;
};

export const useBotStatus = (eventId: string): UseBotStatusResult => {
  const { data, isLoading, error, refetch } = useQuery<{ status: BotStatus }>({
    queryKey: ['botStatus', eventId],
    queryFn: async () => {
      const response = await fetch(`${API_URL}/calendar-events/${eventId}/bot-status`, {
        credentials: 'include',
      });

      if (!response.ok) {
        throw new Error('Failed to fetch bot status');
      }

      return response.json();
    },
    refetchInterval: 10000, // Refetch every 10 seconds for live updates
    refetchOnWindowFocus: true,
  });

  return {
    botStatus: data?.status,
    isLoading,
    error: error as Error | null,
    refetch,
  };
};
